/* global axios */
import ApiClient from './ApiClient';

class WhatsappTemplatesAPI extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  index(inboxId) {
    return axios.get(`${this.url}/${inboxId}/whatsapp_templates`);
  }

  sync(inboxId) {
    return axios.post(`${this.url}/${inboxId}/whatsapp_templates/sync`);
  }

  create(inboxId, template) {
    return axios.post(`${this.url}/${inboxId}/whatsapp_templates`, {
      template,
    });
  }

  update(inboxId, template) {
    const name = encodeURIComponent(template.name);
    const params = template.language ? { language: template.language } : {};
    return axios.put(
      `${this.url}/${inboxId}/whatsapp_templates/${name}`,
      { template },
      { params }
    );
  }

  deleteTemplate(inboxId, template) {
    const name = encodeURIComponent(template.name);
    const params = template.language ? { language: template.language } : {};
    return axios.delete(`${this.url}/${inboxId}/whatsapp_templates/${name}`, {
      params,
    });
  }
}

export default new WhatsappTemplatesAPI();
